import * as React from "react";
const SvgFiRrCheapStackDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cheap-stack-dollar_svg__a)">
      <path
        fill="#062147"
        d="M12.5 6a6 6 0 1 0-12 0c0 .344.035.678.091 1.006C.219 7.463 0 7.968 0 8.5v12C0 22.798 3.27 24 6.5 24s6.5-1.202 6.5-3.5v-12c0-.532-.219-1.038-.591-1.494A6 6 0 0 0 12.5 6M11 16.5c0 .436-1.577 1.5-4.5 1.5S2 16.936 2 16.5v-1.409c1.226.601 2.867.909 4.5.909s3.274-.308 4.5-.909zM3.226 4.066C3.378 2.986 4.334 2.2 5.425 2.2h.28v-.4a.8.8 0 1 1 1.6 0v.4h.274c.711 0 1.348.324 1.77.833a.771.771 0 0 1-.592 1.266h-.076a.8.8 0 0 1-.588-.274c-.128-.139-.386-.226-.589-.226H5.402a.59.59 0 0 0-.587.458.576.576 0 0 0 .449.678l2.792.559a2.177 2.177 0 0 1 1.725 2.439c-.153 1.08-1.108 1.865-2.199 1.865h-.28v.4a.8.8 0 1 1-1.6 0v-.4h-.336c-.67 0-1.273-.287-1.694-.745-.476-.518-.113-1.354.591-1.354.227 0 .434.107.588.274a.7.7 0 0 0 .515.226h2.239a.59.59 0 0 0 .586-.46.576.576 0 0 0-.451-.677l-2.791-.559a2.18 2.18 0 0 1-1.725-2.439zM6.5 12c1.633 0 3.274-.308 4.5-.909V12.5c0 .436-1.577 1.5-4.5 1.5S2 12.936 2 12.5v-1.409c1.226.601 2.867.909 4.5.909m0 10C3.577 22 2 20.936 2 20.5v-1.409c1.226.601 2.867.909 4.5.909s3.274-.308 4.5-.909V20.5c0 .436-1.577 1.5-4.5 1.5m17.207-1.412-2.535 2.535A3 3 0 0 1 19.05 24a3 3 0 0 1-2.121-.876l-2.636-2.636a.999.999 0 1 1 1.414-1.414L18 21.367V1a1 1 0 1 1 2 0v20.467l2.293-2.293a.999.999 0 1 1 1.414 1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cheap-stack-dollar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheapStackDollar;
